export const getAudioTrackFromMediaStream = (mediaStream: MediaStream): MediaStreamTrack | undefined => {
    return mediaStream.getAudioTracks()[0];
};
